// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from "../../../store/store";

import { getLocalUsers } from "../../../store/user/userActions";

export async function localUsers() {
  // get the local users
  await store.dispatch(getLocalUsers("all"));
  return null;
}

localUsers.hydrate = true;
